@if (config(); as config) {
  <dx-load-panel
    shadingColor="rgba(0,0,0,0.4)"
    [message]="config.message"
    [visible]="true"
    [height]="config.height"
    [width]="config.width"
    [position]="{ of: '.app-wrapper' }"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false">
  </dx-load-panel>
}
